import axios from '../axios';

export const all = (params = {}) => {
  return axios.get('/returns', { params });
};

export const show = (id) => {
  return axios.get(`/returns/${id}`);
};

export const updateStatus = (id, payload) => {
  return axios.patch(`/returns/${id}/status`, payload);
};

export const getSettings = () => {
  return axios.get('/returns/settings');
};

export const updateSettings = (payload) => {
  return axios.put('/returns/settings', payload);
};

export const reasons = () => {
  return axios.get('/returns/reasons');
};

export const createReason = (payload) => {
  return axios.post('/returns/reasons', payload);
};

export const updateReason = (id, payload) => {
  return axios.put(`/returns/reasons/${id}`, payload);
};

export const destroyReason = (id) => {
  return axios.delete(`/returns/reasons/${id}`);
};
